import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Helper } from '../pages/common/helper';

@Injectable({
  providedIn: 'root'
})
export class PhotoCarouselService {

  constructor(private http: HttpClient) {

  }

  getApplicationList() {
    return this.http.get(Helper.API_URL() + '/api/Maintenance/GetIFSApplicationList');
  }

  getPhotoCarouselList(userID: string, applicationID: string) {

    // convert to httpPost
    let paramObject = {
      'applicationID': applicationID
    }

    return this.http.post(Helper.API_URL() + '/api/IFSBackground/GetPhotoCorouselList', paramObject);
  }

  createPhotoCarousel(data: any) {

    return this.http.post(Helper.API_URL() + '/api/Maintenance/CreatePhotoCorousel', data);
  }

  updatePhotoCarousel(data: any) {

    return this.http.post(Helper.API_URL() + '/api/Maintenance/UpdatePhotoCorousel', data);
  }

  deletePhotoCarousel(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Maintenance/DeletePhotoCorousel', data);
  }

  getPhotoCarouselImageDirectoryPath() {
    return this.http.get(Helper.API_URL() + '/api/IFSBackground/GetPhotoCarouselImageDirectoryPath');
  }

  uploadPhotoCarouselImage(file: any) {
    return this.http.post(Helper.API_URL() + '/api/Maintenance/UploadPhotoCarouselImage', file);
  }
  savePhotoCarouselImage(data: any) {
    return this.http.post(Helper.API_URL() + '/api/Maintenance/SavePhotoCarouselImage', data);
  }
  
}
